// extracted by mini-css-extract-plugin
module.exports = {"bb-webform":"bb-webform__P_d7t"};